import * as React from "react";
import { SVGProps } from "react";
export const SquareTickFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.91111 11.0889L7.23889 9.41667C7.0963 9.27407 6.91481 9.20278 6.69444 9.20278C6.47407 9.20278 6.29259 9.27407 6.15 9.41667C6.00741 9.55926 5.93611 9.74074 5.93611 9.96111C5.93611 10.1815 6.00741 10.363 6.15 10.5056L8.36667 12.7222C8.52222 12.8778 8.7037 12.9556 8.91111 12.9556C9.11852 12.9556 9.3 12.8778 9.45556 12.7222L13.85 8.32778C13.9926 8.18519 14.0639 8.0037 14.0639 7.78333C14.0639 7.56296 13.9926 7.38148 13.85 7.23889C13.7074 7.0963 13.5259 7.025 13.3056 7.025C13.0852 7.025 12.9037 7.0963 12.7611 7.23889L8.91111 11.0889ZM4.55556 17C4.12778 17 3.76157 16.8477 3.45694 16.5431C3.15231 16.2384 3 15.8722 3 15.4444V4.55556C3 4.12778 3.15231 3.76157 3.45694 3.45694C3.76157 3.15231 4.12778 3 4.55556 3H15.4444C15.8722 3 16.2384 3.15231 16.5431 3.45694C16.8477 3.76157 17 4.12778 17 4.55556V15.4444C17 15.8722 16.8477 16.2384 16.5431 16.5431C16.2384 16.8477 15.8722 17 15.4444 17H4.55556Z"
            fill="currentColor"
        />
    </svg>
);
SquareTickFillIcon.displayName = "SquareTickFillIcon";
